/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ForumDetailComment.vue?vue&type=template&id=54297524&scoped=true&"
import script from "./ForumDetailComment.vue?vue&type=script&setup=true&lang=js&"
export * from "./ForumDetailComment.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ForumDetailComment.vue?vue&type=style&index=0&id=54297524&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54297524",
  null
  
)

export default component.exports